import { Timestamp } from '@bufbuild/protobuf';

import { Pipe, PipeTransform } from '@angular/core';

type DateDifferenceValue =
  Date | string | number | Timestamp | undefined | null;

@Pipe({
  name: 'dateDifference',
  standalone: false,
})
export class DateDifferencePipe implements PipeTransform {
  transform(
    minDifference: number,
    eventTime: DateDifferenceValue,
    prevEventTime: DateDifferenceValue
  ): boolean {
    if (!prevEventTime) {
      return true;
    }
    const difference = minDifference * 60 * 1000;
    const timeDiff = Math.abs(
      this.toMilliseconds(eventTime) - this.toMilliseconds(prevEventTime)
    );

    return timeDiff > difference;
  }

  /** Normalizes proto `Timestamp`s (and plain dates) to epoch milliseconds. */
  private toMilliseconds(value: DateDifferenceValue): number {
    if (!value) {
      return Number.NaN;
    }

    if (typeof value === 'object' && 'nanos' in value) {
      return value.toDate().getTime();
    }

    return new Date(value).getTime();
  }
}
